import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {validateHandler,clearIsValid,clearPhone,blurHandler,changeHandler, goToPage, addContact, setDefaultSong, addPhoneInput,setSongSetupSuccessPage, setErrorType, reportAnalytics} from '../../fundialSlice';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import PopUp from '../../../../Shared/Popup/PopUp';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';


const SongSetup = (props) => {
    const [selected, setSelected] = useState('defaultSong');
    const [showAddContact, setShowAddContact] = useState(false);
    const [phoneList, setPhoneList] = useState([]);
    const [showAlertPopUp, setShowAlertPopUp] = useState(false);
    const [radioBtns, setRadioBtns] = useState([ 
      {id: 'defaultSong', label: 'לכולם, למעט אנשי קשר שמוגדר להם שיר ייעודי' },
      {id: 'contacts', label: 'לאיש קשר מסוים אחד או יותר' },
      {id: 'storage', label: 'תוסיפו לשירים שלי, אגדיר אחר כך' },
      ]);


    useEffect(() => {
      props.addPhoneInput({id:'phone-'+ props.selectedSong.id , isActive: false , value: ''})
      if(props.subscriber.isBusinessTone){
        setRadioBtns(radioBtns.filter(item => item.id !== 'defaultSong'));
        setSelected('contacts');
      }
    },[])


  function handleOptionChange(e) {
    let value = e.currentTarget.value;
    setSelected(value)  
  }

  function closeContact(inputPhoneId){
    props.clearIsValid();
    props.clearPhone(inputPhoneId);
    setShowAddContact(false);
  }

  function addContact(inputPhoneId){
    var inputPhone = props.form.phones[inputPhoneId].value;
    if(!phoneList.includes(inputPhone)){
    setPhoneList([...phoneList,inputPhone]);
    closeContact(inputPhoneId);
    }
  }

  function removeContact(phone){
    setPhoneList(phoneList.filter(item => item != phone));
  }

  function continueBtn(){
    if(selected == 'contacts' && phoneList.length == 0){
      setShowAlertPopUp(true);
    }
    else if(selected == 'contacts'){
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_DownloadSuccess_SetContacts",
        eventLabel: "",
      });
      async function addContact() {
        props.showAppLoader();
        var result = await  props.addContact({subscriber : props.subscriber.cli , songId: props.selectedSong.id , phoneNumbers: phoneList });
        props.hideAppLoader(); 
        if(result.payload.errorCode != 0) {
          props.setErrorType({errorType: "ADD_CONTACT_ERROR"})
          props.goToPage({page: 'errorPage'});
        }
        else {
          props.setSongSetupSuccessPage({type: "contacts"});
          props.goToPage({page: "songSetupSuccessPage"});
        }
      }
      addContact();
    }
    else if(selected == 'defaultSong'){
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_DownloadSuccess__SetToAll",
        eventLabel: "",
      });
      async function setDefaultSong() {
        props.showAppLoader();
        var result = await props.setDefaultSong({subscriber: props.subscriber.cli , productId: props.selectedSong.id });
        props.hideAppLoader(); 
        if(result.payload.errorCode != 0) {
          props.setSongSetupSuccessPage({type: "storage"});
        }
        else {
          props.setSongSetupSuccessPage({type: "defaultSong"});
        }
        props.goToPage({page: "songSetupSuccessPage"});

      }
      setDefaultSong();
    }
    else if(selected == 'storage'){
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_DownloadSuccess_SaveForLater",
        eventLabel: "",
      });
      props.setSongSetupSuccessPage({type: "storage"});
      props.goToPage({page: "songSetupSuccessPage"});
    }

  }

  return (
    <>
      <div className='song-setup'>
        <div className='header'>
          <p className='title'>למי תרצו להשמיע אותו?</p>
        </div>
        <div className='content'>
          <span className='separator bold' />
          {radioBtns.map((btn, i) => (
            <div key={i}>
              <RadioInput
                checked={selected == btn.id}
                id={btn.id}
                name='songSetup'
                value={btn.id}
                label={btn.label}
                onChange={handleOptionChange}
              />
              {btn.id == 'contacts' && !showAddContact && (
                <button
                  className='add-contact-btn'
                  onClick={() => {
                    setShowAddContact(!showAddContact);
                  }}>
                  בחר איש קשר
                </button>
              )}
              {btn.id == 'contacts' &&
                phoneList.length > 0 &&
                phoneList.map((phone, j) => (
                  <div key={j} className='contact'>
                    <div className='cli'>{phone}</div>
                    <button
                      onClick={() => {
                        removeContact(phone);
                      }}
                      className='remove-contact-btn'></button>
                  </div>
                ))}
              {btn.id == 'contacts' && showAddContact && (
                <div className='wrapper-form-add-contact'>
                  <div className='input-wrapper'>
                    <TextInput
                      className='phone-input'
                      name={'phone-'+props.selectedSong.id}
                      type='number'
                      pattern='[0-9]*'
                      id={'phone-'+props.selectedSong.id}
                      maxLength='10'
                      autoComplete='off'
                      placeholder={'מספר טלפון של איש קשר'}
                      required='required'
                      value={props.form.phones['phone-'+props.selectedSong.id].value}
                      error={props.form.multipleErrors['phone-'+props.selectedSong.id]}
                      onBlur={(e) => props.blurHandler({target: e.target, form: props.form})}
                      onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                      onWheel={(e) => e.target.blur()}
                    />
                    <button onClick={() => {closeContact('phone-'+props.selectedSong.id);}} className='remove-contact-btn'></button>
                  </div>

                  <div className='btn-wrapper'>
                    <BtnSubmit
                      onclick={() => {
                        addContact('phone-'+props.selectedSong.id);
                      }}
                      text='הוסף איש קשר'
                      formid='fundial-add-contact'></BtnSubmit>
                  </div>
                </div>
              )}
              <span className='separator' />
            </div>
          ))}
          <div className='btn-wrapper'>
            <BtnSubmit
              onclick={() => {
                continueBtn();
              }}
              text={'המשך'}
            />
          </div>
        </div>
      </div>
      <PopUp
        className='song-setup-alert-popup'
        showPopUp={showAlertPopUp}
        onClose={() => {
          setShowAlertPopUp(false);
        }}>
        <h1>שים לב!</h1>
        <p>נא לבחור איש קשר כדי להמשיך</p>
      </PopUp>
    </>
  );
};

const mapStateToProps = (state) => {
    return {
        form: state.fundialPage.form,
        selectedSong: state.fundialPage.selectedSong,
        subscriber: state.fundialPage.selectedSubscriber,
        aocDetails: state.fundialPage.aocDetails,
    };
  };
  
  const mapDispatchToProps = {
    validateHandler,
    clearIsValid,
    clearPhone,
    blurHandler,
    changeHandler,
    goToPage,
    showAppLoader,
    hideAppLoader,
    addContact,
    setDefaultSong,
    addPhoneInput,
    setSongSetupSuccessPage,
    setErrorType,
    reportAnalytics
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(SongSetup);